<template>
    <div class="indicator-style6">
        <div class="indicator-style-item-content">
            <div class="indicator-style-item bi_dashboard_text_overflow"
                style="margin-bottom: 4px;line-height: 1.5;font-weight: 700;text-align: center;" :title="info.rowValue">
                {{ info.rowValue }}
            </div>
            <div class="jzliu-cli-bi-engine-list-content">
                <div style="display: flex;align-items: center;justify-content: center;">
                    <style-icon style="width:45px;height:45px;margin-right:6px"
                        v-if="chartData.styleConfig.commongConfig.indicatorIcon" :chartData="chartData"
                        :rowValue="info.rowValue" :idx="idx" />
                    <div class="bi_dashboard_text_overflow" :title="info.measureName">{{ info.measureName }}</div>
                </div>
                <div class="bi_dashboard_text_overflow" style="font-size: 28px;font-weight: 700;" :title="transferWhiteVal(info.measureValue)">{{
                    transferWhiteVal(info.measureValue) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { transferWhiteVal } from '../../../utils'
import styleIcon from './styleIcon.vue'
export default {
    name: 'style6',
    components: {
        styleIcon,
    },
    props: {
        info: {
            type: Object,
            default: () => { },
        },
        chartData: {
            type: Object,
            default: () => { },
        },
        idx: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            transferWhiteVal,
        }
    },
}
</script>

<style scoped lang="less">
.indicator-style6 {
    .jzliu-cli-bi-engine-list-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
